/**
 * Map Data Counter Component
 *
 * Displays count of stores/marketers with loading indicator
 * following Single Responsibility Principle
 */

import React from 'react';

export interface MapDataCounterProps {
  count: number;
  type: 'stores' | 'marketers';
  isUpdating?: boolean;
}

export const MapDataCounter: React.FC<MapDataCounterProps> = ({
  count,
  type,
  isUpdating = false
}) => {
  const label = type === 'stores' ? 'متجر' : 'مسوق';

  return (
    <div className="absolute top-4 right-4 z-10 bg-white rounded-lg shadow-lg px-3 py-2">
      <div className="flex items-center gap-2">
        <div className="text-sm font-medium text-gray-700">
          {count} {label}
        </div>
        {isUpdating && (
          <div
            className="w-3 h-3 border border-brand-300 border-t-blue-500 rounded-full animate-spin"
            title="جاري التحديث"
            aria-label="جاري التحديث"
          />
        )}
      </div>
    </div>
  );
};

export default MapDataCounter;
